import axios, { AxiosResponse } from "axios";

export const userService = {
  checkRelatedPolices: (email: string): Promise<AxiosResponse<any>> => {
    if (email === null || email.trim() === "") {
      return new Promise<AxiosResponse<any>>((resolve, reject) =>
        reject("no email")
      );
    }
    return axios.post(`/check?email=${encodeURIComponent(email)}`, null, {
      headers: { "content-type": "application/json" }
    });
  },

  getMinimumStartDate:():Promise<AxiosResponse<any>> => {
    return axios.get(`/startdate`, {
      headers: { "content-type": "application/json" }
    });
  }
};
